import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import StandardizedChip from '../../common/StandardizedChip';

/**
 * PolicyDataFieldsTab Component
 *
 * Displays supported data fields for the policy.
 *
 * @param {Object} props
 * @param {Array} props.dataFields - Array of data field names
 * @param {boolean} props.loading - Whether data fields are loading
 */
function PolicyDataFieldsTab({ dataFields, loading }) {
  if (loading) {
    return <Alert severity="info">Loading data fields...</Alert>;
  }

  if (!dataFields || dataFields.length === 0) {
    return (
      <Alert severity="info">
        No specific data fields defined for this policy
      </Alert>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Supported Data Fields
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        This policy can detect and filter the following data field types:
      </Typography>
      <Box display="flex" flexWrap="wrap" gap={1}>
        {dataFields.map((field, index) => {
          const formattedLabel = field
            .replace(/_/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase());
          return (
            <StandardizedChip
              key={index}
              label={formattedLabel}
              variant="outlined"
              color="primary"
            />
          );
        })}
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Total: {dataFields.length} data field types supported
      </Typography>
    </Box>
  );
}

export default PolicyDataFieldsTab;
